// Header — identificação do app + status global (lojas conectadas), ações (tema,
// notificações placeholder) e bloco do usuário. Sair fica na sidebar.
import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/app/router/paths';
import { Avatar } from '@/components/ui/Avatar';
import { Badge } from '@/components/ui/Badge';
import { NumberRestrictionBadge } from '@/features/metrics';
import { ThemeToggle } from '@/components/ui/ThemeToggle';
import { BellIcon } from '@/components/icons';
import { selectCurrentUser, selectOnboardingComplete, selectStoreIds } from '@/features/auth';
import styles from './Header.module.css';

const ROLE_LABEL: Record<string, string> = {
  GESTOR: 'Gestor(a)',
  GERENTE: 'Gerente',
  VENDEDOR: 'Colaborador',
  ATENDENTE: 'Atendente',
  PRODUCAO: 'Produção',
};

export function Header() {
  const user = useAppSelector(selectCurrentUser);
  const storeIds = useAppSelector(selectStoreIds);
  const onboardingComplete = useAppSelector(selectOnboardingComplete);

  return (
    <header className={styles.header} role="banner">
      <div className={styles.left}>
        <h2 className={styles.title}>ChatIa</h2>
        {user && storeIds.length > 0 && (
          <Badge variant="success" className={styles.storesBadge}>
            {storeIds.length} {storeIds.length === 1 ? 'loja conectada' : 'lojas conectadas'}
          </Badge>
        )}
      </div>
      <div className={styles.right}>
        {/* MET-22: só o SINAL de restrição, nunca a nota de qualidade — o badge
            lê `canal/restricao`, que não carrega `qualityRating`. */}
        {user && <NumberRestrictionBadge />}
        {/* No mobile o tema vive no MoreSheet; aqui esconde pra sobrar espaço. */}
        <span className={styles.themeToggle}>
          <ThemeToggle />
        </span>
        {user ? (
          <>
            {!onboardingComplete && user.role === 'GESTOR' && (
              <a className={styles.onboardingLink} href={ROUTES.onboarding}>
                Onboarding
              </a>
            )}
            <button
              type="button"
              className={styles.iconButton}
              aria-label="Notificações"
              title="Notificações (em breve)"
            >
              <BellIcon size={16} />
            </button>
            <Badge
              variant={user.role === 'GESTOR' ? 'purple' : 'green'}
              className={styles.roleBadge}
            >
              {ROLE_LABEL[user.role] ?? user.role}
            </Badge>
            <span className={styles.userName}>{user.name}</span>
            <Avatar name={user.name} tone={user.avatarTone} size="sm" src={user.avatarUrl} />
          </>
        ) : (
          <span className={styles.userName}>Não autenticado</span>
        )}
      </div>
    </header>
  );
}
